import React, { ReactNode } from 'react'
import styles from './AppButton.module.scss'
import { Loading } from '../Loading';
import classNames from 'classnames';
export function AppButton(props: {
    title?: string;
    children?: ReactNode;
    onClick?: () => void;
    loading?: boolean;
    disabled?: boolean
}) {
  return (
    <div onClick={props.disabled ? undefined : props.onClick} className={classNames(styles.container, {
      [styles.disabled]: props.disabled
    })}>
        {props.loading ? <Loading fill='#fff' size={20}/> : null}
        {!props.loading ? (props.title ? <label>{props.title}</label> : props.children) : null}
    </div>
  )
}
